import auth from "./modules/auth";
import dashboard from "./modules/dashboard";
import SalesManagement from "./modules/SalesManagement";
import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
export default {
  namespaced: true,
  modules: { auth, dashboard, SalesManagement },
  state,
  actions,
  mutations,
  getters,
};
